import Http from '@services/httpClient';
import { ClientRequest } from '@common/ApiTypes';

const prefix = '/api/v1/llm/cv';

export default {
  parseCV(data: FormData) {
    return new Promise((resolve, reject) => {
      const req: ClientRequest = {
        data,
        url: `${prefix}/parse`,
      };

      Http.postUpload(req)
        .then((res) => resolve(res))
        .catch((e) => reject(e));
    });
  },

  recommWorkProfile(data: object) {
    return new Promise((resolve, reject) => {
      const req: ClientRequest = {
        data,
        url: `${prefix}/generate/work-profile`,
      };

      Http.post(req)
        .then((res) => resolve(res))
        .catch((e) => reject(e));
    });
  },

  recommWorkExp(data: object) {
    return new Promise((resolve, reject) => {
      const req: ClientRequest = {
        data,
        url: `${prefix}/generate/work-experience`,
      };

      Http.post(req)
        .then((res) => resolve(res))
        .catch((e) => reject(e));
    });
  },

  recommEducations(data: object) {
    return new Promise((resolve, reject) => {
      const req: ClientRequest = {
        data,
        url: `${prefix}/generate/educations`,
      };

      Http.post(req)
        .then((res) => resolve(res))
        .catch((e) => reject(e));
    });
  },

  recommSkills(data: object) {
    return new Promise((resolve, reject) => {
      const req: ClientRequest = {
        data,
        url: `${prefix}/generate/skills`,
      };

      Http.post(req)
        .then((res) => resolve(res))
        .catch((e) => reject(e));
    });
  },
};
